//import loggingService from '@/services/util/loggingService'

//var serviceName = 'publicReportService'
var path = '/PublicReport/'
//var isDebug = false

function getIncidentPublicReport (http) {
    return http.get(path + 'GetIncidentPublicReport', { responseType: 'arraybuffer' }).then(response => {
        return response
    })
}

export default {
    getIncidentPublicReport: getIncidentPublicReport
}
